module.exports = __webpack_public_path__ + "img/logo.bbd0de83.png";